<template>
  <article class="t-left pcinner">
    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
    <div class="entry-content">
      <h1 class="pginner">新着アイテム</h1>
      <ItemList v-bind:ItemList="itemList" v-bind:ItemTotal="itemTotal" />
      <nav v-if="isLoading == false" class="pagerbox">
        <paginate
          v-model="itemPage"
          :page-count="itemPageTotal"
          :page-range="2"
          :margin-pages="1"
          :prev-text="'<'"
          :next-text="'>'"
          :click-handler="clickCallback"
          :container-class="'pagination'"
          :page-class="'pagerL'"
          :prev-class="'pagerL'"
          :next-class="'pagerL'"
          >
        </paginate>
      </nav>
    </div>
  </article>
</template>

<script>
import axios from 'axios'
import ItemList from '@/components/ItemList.vue'
import Paginate from 'vuejs-paginate';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'brand',
  components: {
    ItemList,
    Paginate,
    Loading
  },
  data () {
    return {
      detail: [],
      itemList: [],
      brandCode:'',
      itemTotal: 0,
      itemPageTotal: 0,
      itemPage: 1,
      isLoading: false,
      fullPage: true,
    }
  },
  created () {
    this.initialize()
    this.setupPage(this.$route)
  },
  watch: {
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize()
    this.setupPage(to)
    next();
  },
  methods: {
    initialize() {
      this.refresh();
    },
    refresh() {
      this.detail = {}
      this.itemList = {}
      this.itemTotal = 0
      this.itemPageTotal = 0
      this.itemPage = 1
      this.isLoading= false
    },
    setupPage(route) {
      // header
      let title = 'sports style'
      let description = 'sports styleのTOPページ。スポーツブランドのアイテムをカテゴリごと、価格ごと、性別ごとに探すことができます。'
      this.setHeader(title, description)
      // Loading
      this.isLoading = true
      if(route.query.page){
          this.itemPage = route.query.page
      }
      axios.get('https://app3.sportsstyle.net/items/list/')
      .then((res) => {
        this.itemList = res.data.list
        this.itemTotal = res.data.item_total
        this.itemPageTotal = res.data.page_total
        this.isLoading = false
      })
      .catch(() =>{
        console.log('item list not found')
       // this.$router.push({ name: "404"})
      })
    },
    clickCallback(pageNum) {
      // console.log(pageNum)
      this.$router.push({ name: "itemList", query:{page: pageNum}})
    }
  }
}
</script>
